import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Navigate } from "react-router-dom";
import {
  Button,
  TextField,
  Typography,
  Alert,Collapse,
  Box
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {InputAdornment} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import NotesIcon from '@mui/icons-material/Notes';
import SubmitIcon from "./images/SUBMIT-ICON.jpg";
import Serverurl from "./Apiurl";

class ExpenseForm extends Component {
  constructor(props) {
    super(props);

 

    this.state = {
      type: "expense",
     
      expenseRecordId:  "0",

      projectarrauto: [],
      selectedProjectInsert: null,
      pi_pj_id: "",
	  previocn : "",

      expensearrauto: [],
      selectedExpense: null,
      exp_category_id: "",
      expence: "",
expenseImage:"",
      pi_id: "",
      pi_date: dayjs(),
      pi_amount: "",
      pi_remarks: "",
expenseFile:"",
redirect:false,pagename:"",
      submitbtn: "Submit",
      isDisabled: false,
      loading: false,

      successMsg: "",
      errormessage: "",
      erropen: false,
      errorty: "error"
    };
  }

  componentDidMount() {
	  	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
     const params = new URLSearchParams(window.location.search);
    const expenseId = params.get("exp_id");

    if (
      expenseId!=null
    ) {
      this.loadPayment(expenseId);
    }
	
	
	let strname="Enter Expenses";   
			 this.props.parentsCallback(
           strname
        );
  }
loadPayment = (id) => {
  axios.get(Serverurl + "ajaxexpenses.php", {
    params: {
      action: "getexpensesall",
      exp_id: id
    }
  })
  .then((res) => {
    if (res.data.length > 0) {
      
      this.setState({
        expenseRecordId: res.data[0].exp_id,
        selectedProjectInsert: {title: res.data[0].ProjectName, pj_id: res.data[0].exp_pj_id},
        pi_pj_id:res.data[0].exp_pj_id,
        pi_date: dayjs(res.data[0].ExpenseDate),
        pi_amount: res.data[0].Amount ,
        pi_remarks: res.data[0].Remarks ,
		selectedExpense: {title: res.data[0].CategoryName ,se_id: res.data[0].exp_categoryname} ,
        exp_category_id: res.data[0].exp_categoryname,
		
		existingImage: res.data[0].Photo,
          existingFile: res.data[0].bill,
		
      });
    }
  })
  .catch((error) => {
   
  });
};


onloadExpensesAutoextender = (event) => {
    const expense = event?.target?.value?.trim() || "";

    if (!expense) {
      this.setState({
        expensearrauto: []
      });
      return;
    }

    axios
      .get(Serverurl + "ajaxexpensesandservices.php", {
        params: {
          action: "expautoextender",
          se_servicename: expense
        }
      })
      .then((res) => {
        

        const list = res.data.map((r) => ({
          title: r.se_servicename || "",
          se_id: r.se_id,
         
        }));

        this.setState({
          expensearrauto: list
        },()=>{});
		
		
      })
      .catch((error) => {


        this.setState({
          expensearrauto: []
        });
      });
  };

  onloadProjectBind = (event) => {
    const projectName = event?.target?.value?.trim() || "";

    if (!projectName) {
      this.setState({
        projectarrauto: []
      });
      return;
    }

    axios
      .get(Serverurl + "ajaxprojects.php", {
        params: {
          action: "getallprojectautoextender",
          projectname: projectName
        }
      })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];

        const list = data.map((r) => ({
          title: r.pj_projectname || "",
          pj_id: r.pj_id,
          finalized: Number(r.pj_finalizedamount) || 0
        }));

        this.setState({
          projectarrauto: list
        });
      })
      .catch((error) => {
        console.error("Error loading projects:", error);

        this.setState({
          projectarrauto: []
        });
      });
  };

onProjectChange = (event, value) => {
  this.setState({
    selectedProjectInsert: value,
    pi_pj_id: value ? value.pj_id : ""
  });
};
  onExpenseChange = (event, value) => {
    this.setState({
      selectedExpense: value,
      exp_category_id: value ? value.se_id : "",
      
    });
  };

onFileChange = (e) => {
	
  let expenseupFile =e.target.files[0];

  if (!expenseupFile || expenseupFile.length === 0) {
    return;
  }

  if (expenseupFile.type.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG|pdf|doc|xls)$/)) {
    this.setState({ errormessage: "Please select a .xls,.doc,.pdf,.jpg", erropen: true, errorty: "error", expenseFile: null });
    e.target.value = "";
    return;
  }

  if (expenseupFile.size > 900 * 1024) {
    this.setState({ errormessage: "File size should be less than or equal to 900KB.", erropen: true, errorty: "error", expenseFile: null });
    e.target.value = "";
    return;
  }

  this.setState({ expenseFile: expenseupFile, errormessage: "", erropen: false },()=>{});
};
  

 onImageChange = (e) => {
  let imageFile = e.target.files[0];

  if (!imageFile || imageFile.length === 0) {
    return;
  }

  if (!imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
    this.setState({ errormessage: "Please select a valid file (jpg, jpeg, png).", erropen: true, errorty: "error" });
    window.scrollTo({ top: 0 });
    return false;
  }

  if (imageFile.size > 900*1024) {
    this.setState({ errormessage: "File size should be less than or equal to 900KB.", erropen: true, errorty: "error" });
    window.scrollTo({ top: 0 });
    return false;
  }

  this.setState({ expenseImage: imageFile, errormessage: "", erropen: false });
};
	handeldate = (date) => {
	  var month = "";
	  var date1 = new Date(date);

	  if ((date1.getMonth() + 1) < 10) {
		month = "0" + (date1.getMonth() + 1);
	  } else {
		month = date1.getMonth() + 1;
	  }

	  this.setState({pi_date: dayjs(date)});
	};


  handleErrorclose = () => {
    this.setState({
      erropen: false
    });
  };

 

insertPayments = () => {
 const {
      pi_pj_id,
      exp_category_id,
      pi_date,
      pi_amount
    } = this.state;

    if (!pi_pj_id) {
      this.setState({
        errormessage: "Please Select Project",
        erropen: true,
        errorty: "error"
      });
      return false;
    }

    if (!exp_category_id) {
      this.setState({
        errormessage: "Please Select Expense",
        erropen: true,
        errorty: "error"
      });
      return false;
    }

    if (!pi_date || !dayjs(pi_date).isValid()) {
      this.setState({
        errormessage: "Please Select a Valid Date",erropen: true,errorty: "error"
      });
      return false;
    }

    if (!pi_amount || Number(pi_amount) <= 0) {
      this.setState({
        errormessage: "Please Enter Valid Amount",
        erropen: true,
        errorty: "error"
      });
      return false;
    }



this.setState({ isDisabled: true, submitbtn:  "Processing...", errormessage: "", erropen: false });

let formData = new FormData();

if (this.state.expenseRecordId!="0") {
formData.append("action", "insert");
formData.append("exp_id", this.state.expenseRecordId);
} else {
formData.append("action", "insert");
formData.append("exp_id", 0);
}

formData.append("exp_date", dayjs(this.state.pi_date).format("YYYY-MM-DD"));
formData.append("exp_pj_id", this.state.pi_pj_id);
formData.append("exp_categoryname", this.state.exp_category_id);
formData.append("exp_amount", this.state.pi_amount);
formData.append("exp_remarks", this.state.pi_remarks);
formData.append("userid", localStorage.getItem("VRuserid"));


if (this.state.expenseImage) {
  formData.append("exp_image", this.state.expenseImage);
} else if (this.state.existingImage) {
  formData.append("existing_image", this.state.existingImage);
}


if (this.state.expenseFile) {
  formData.append("exp_bill", this.state.expenseFile);
} else if (this.state.existingFile) {
  formData.append("existing_bill", this.state.existingFile);
}

axios.post(Serverurl + "ajaxexpenses.php", formData).then((res) => {
this.setState({ isDisabled: false, submitbtn: "Submit", errormessage:  "Expense submitted successfully!", erropen: true, errorty: "success",redirect: true,
  pagename: "/Expensedisplay", });

}).catch((error) => {



});
};


  render() {
	  
	  if (this.state.redirect === true) {
    return <Navigate to={this.state.pagename} />;
  }
	  
    return (
      <React.Fragment>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box>
           
 <Collapse in={this.state.erropen}>
          
              <Alert
                severity={
                  this.state.errorty === "success"
                    ? "success"
                    : "error"
                }
                onClose={this.handleErrorclose}
                sx={{ mb: 2 }}
              >
                {this.state.errormessage}
              </Alert>
           
			 </Collapse>
<div className="txtprojfrm">
<p>
           
              Project </p> 

               <p>  <Autocomplete
			     tabIndex={1} 
                className="inputcntlparent"
                options={this.state.projectarrauto}
                value={this.state.selectedProjectInsert}
                onChange={this.onProjectChange}
                getOptionLabel={(option) => option?.title || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.pj_id === value?.pj_id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    placeholder="Select Project"
                    onChange={this.onloadProjectBind}
					
                  />
                )}
              />   </p>
            </div>

           		  <div className="txtprojfrmryt">
              <p>Date</p>

           <p>   <DatePicker   tabIndex={2} 
                disableFuture name="pi_date"
                className="inputcntlparent"
                format="DD/MM/YYYY"
                value={this.state.pi_date}
                onChange={this.handeldate}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
					inputProps: {
              tabIndex: 2, // Set your desired tab index here
            },
                  }
                }}
              /></p>
            </div>
 <div className="clear"></div>

<div className="txtprojfrm">
              <p>Expense</p>

              <p>    <Autocomplete tabIndex={3} 
                className="inputcntlparent" name="selectedExpense"
                options={this.state.expensearrauto}
                value={this.state.selectedExpense}
                onChange={this.onExpenseChange}
                getOptionLabel={(option) => option?.title || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.se_id === value?.se_id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    placeholder="Select Expense"
					 onChange={this.onloadExpensesAutoextender}
					
                  />
                )}
              /></p>
            </div>


  <div className="txtprojfrmryt">
           
              <p>Upload Image</p>

              <p className="upload-submitimg">
                <Button
                  variant="outlined"
                  className="upldbtn"
                  endIcon={<PhotoCamera />}
                  component="label"
                >
                  Upload Image

                  <input
                    id="expense-image-input"
                    type="file"
                    hidden
                    name="exp_image"
                    accept="image/jpeg,image/jpg,image/png"
                    onChange={this.onImageChange}
                  />
                </Button>
              </p>

              {this.state.expenseImage && (
                <Typography variant="body2">
                  Selected Image:{" "}
                  <strong>
                    {this.state.expenseImage.name}
                  </strong>
                </Typography>
              )}

              {this.state.existingImage && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2">
                    Existing Image:
                  </Typography>

                  <img
                    src={Serverurl +"uploads/" +this.state.existingImage} style={{width:"80px"}}
                    alt="Existing expense"
                  />
                </Box>
              )}       
            </div>
 <div className="clear"></div>

            <div className="txtprojfrm">
              <p>Upload File</p>

              <p className="upload-submitimg">
                <Button
                  variant="outlined"
                  className="upldbtn"
                  component="label"
                >
                  Choose File

                  <input
                    id="expense-file-input"
                    type="file"
                    hidden
                    name="exp_bill"
                    onChange={this.onFileChange}
                  />
                </Button>
              </p>

              {this.state.expenseFile && (
                <Typography variant="body2">
                  Selected File:{" "}
                  <strong>
                    {this.state.expenseFile.name}
                  </strong>
                </Typography>
              )}

              {this.state.existingFile && (
                <Typography variant="body2">
                  Existing File:{" "}
                  <strong>
				   <a
                    href={Serverurl +"uploads/" +this.state.existingFile} 
                  >View</a>
                  
                  </strong>
                </Typography>
              )}
            </div>

         
 <div className="txtprojfrmryt">
                <p>Amount</p>

             <p>   <TextField
                  fullWidth
                  size="small" name="pi_amount"
                  value={this.state.pi_amount}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (/^\d*\.?\d*$/.test(value)) {
                      this.setState({
                        pi_amount: value
                      });
                    }
                  }}
                 
				  slotProps={{
    htmlInput: {
      maxLength: 10,
      tabIndex: 4
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <CurrencyRupeeIcon   sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
                /></p>
              </div>
 <div className="clear"></div>
              <div className="paytxtbox">
                <p>Remarks</p>
<p>
                <TextField
                  fullWidth
                  size="small" name="pi_remarks"
                  multiline
                  minRows={3}
                  value={this.state.pi_remarks}
                  onChange={(e) =>
                    this.setState({
                      pi_remarks: e.target.value
                    })
                  }
				  
				   slotProps={{
    htmlInput: {
     
      tabIndex: 5
    },
    input: {
      endAdornment: (
         <InputAdornment position="end" sx={{
          alignSelf: "flex-start",  
          mt: "6px"                 
        }}>
          <NotesIcon   sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
                  placeholder="Enter remarks"
                /></p>
              </div>
         

            <div className="clear" />

            <div className="aligncenter">
              <Button
                variant="contained"
                disabled={
                  this.state.isDisabled ||
                  this.state.loading
                }
                onClick={this.insertPayments}
                endIcon={
                  <img
                    src={SubmitIcon}
                    alt="Submit"
                    style={{
                      width: 20,
                      height: 20
                    }}
                  />
                }
              >
                {this.state.submitbtn}
              </Button>
            </div>
          </Box>
        </LocalizationProvider>
      </React.Fragment>
    );
  }
}

export default ExpenseForm;

